import PrimaryCtaType from '~/constants/PrimaryCtaType';
import SecondaryCtaType from '~/constants/SecondaryCtaType';
import { useConfiguration } from '~/context/common/StaticContext';
import usePrimaryCtaButtonState from './usePrimaryCtaButtonState';
import useSecondaryCtaButtonState from './useSecondaryCtaButtonState';

export default function usePrimaryCtaButtonCopy(
  getStartedText?: string
): string | null {
  const { shouldUseTitleCasing } = useConfiguration();
  const { type } = usePrimaryCtaButtonState();
  const { type: secondaryType } = useSecondaryCtaButtonState();
  const defaultGetStartedText = shouldUseTitleCasing
    ? 'Get Started'
    : 'Get started';
  const resolvedGetStartedText = getStartedText ?? defaultGetStartedText;

  const primaryCtaTypes: Record<PrimaryCtaType, string | null> = {
    [PrimaryCtaType.CancelPreOrder]: null,
    [PrimaryCtaType.ContinuePurchase]: shouldUseTitleCasing
      ? 'Continue Purchase'
      : 'Continue purchase',
    [PrimaryCtaType.Default]: resolvedGetStartedText,
    [PrimaryCtaType.DisabledGetStarted]: resolvedGetStartedText,
    [PrimaryCtaType.DisabledPreOrder]: shouldUseTitleCasing
      ? 'Pre-Order Now'
      : 'Pre-order now',
    [PrimaryCtaType.GetAlerts]: shouldUseTitleCasing
      ? 'Get Alerts'
      : 'Get alerts',
    [PrimaryCtaType.GetStarted]: resolvedGetStartedText,
    [PrimaryCtaType.NotifyMe]: shouldUseTitleCasing ? 'Notify Me' : 'Notify me',
    [PrimaryCtaType.Reservable]: shouldUseTitleCasing
      ? 'Pre-Order Now'
      : 'Pre-order now',
    [PrimaryCtaType.Reservation]: null,
    [PrimaryCtaType.ViewSimilarVehicles]:
      secondaryType === SecondaryCtaType.Default
        ? shouldUseTitleCasing
          ? 'View Similar Vehicles'
          : 'View similar vehicles'
        : shouldUseTitleCasing
        ? 'View Similar'
        : 'View similar'
  };

  return primaryCtaTypes[type];
}
